import type { ProductRowReadOnlyItem } from '@/feature/product/components/product-row-read-only/ProductRowReadOnly.client'
import type { ShippingBlock } from '@/feature/shipping/services/shipping.tracking'
import type {
  ClickAndCollectStatus,
  ResolveClickAndCollectOfCartItemsDrawer_ItemsFragment,
} from '@gql-generated/graphql'
import { atom } from 'jotai'
import { atomWithReset } from 'jotai/utils'

type CartAtomType = boolean
type CartShippingContactDrawerAtomType = {
  isOpen: boolean
  shippingBlock?: ShippingBlock
}
type AddToCartDrawerType = {
  isOpen: boolean
  cartItems: ProductRowReadOnlyItem[]
  quantity: number
  cartId: string
  clickAndCollectStatus?: ClickAndCollectStatus | null
}

export const isLoggedInCartVisibleAtom = atom<CartAtomType>(false)
export const isSignedOutCartVisibleAtom = atom<CartAtomType>(false)
export const cartRecalculatingAtom = atom<
  'idle' | 'refreshing' | 'adding' | 'updating' | 'rescheduling'
>('idle')
export const recalculatingCartItemReferenceAtom = atom<string | null>(null)

export const addToCartDrawerDataAtom = atomWithReset<AddToCartDrawerType>({
  isOpen: false,
  cartItems: [],
  quantity: 1,
  cartId: '',
  clickAndCollectStatus: null,
})
export const cartShippingContactDrawerAtom = atom<CartShippingContactDrawerAtomType>({
  isOpen: false,
  shippingBlock: undefined,
})
export const isCartShippingInformationDrawerOpenAtom = atom<CartAtomType>(false)

type CartWarningsType = {
  items: ResolveClickAndCollectOfCartItemsDrawer_ItemsFragment[]
  cartId: string
} | null

export const cartWarningsAtom = atom<CartWarningsType>(null)

export const openCartWarningsDrawer = atom(
  null,
  (
    _,
    set,
    payload: { items: ResolveClickAndCollectOfCartItemsDrawer_ItemsFragment[]; cartId: string },
  ) => set(cartWarningsAtom, payload),
)

export const closeCartWarningsDrawer = atom(null, (_, set) => set(cartWarningsAtom, null))

export const isConvertOrderRequestDeliveryDrawerOpenAtom = atom<boolean>(false)

export const closeConvertOrderRequestDeliveryDrawer = atom(null, (_, set) =>
  set(isConvertOrderRequestDeliveryDrawerOpenAtom, false),
)
